module.exports = __webpack_public_path__ + "img/image_step_3.205219dd.png";